import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import ArticleContent from '../../components/Pages/Article';

const { displayName } = config;

export default function Article(): React.ReactNode | null {
  document.title = `${displayName}: Article details`;

  return (
    <Layout>
      <ArticleContent />
    </Layout>
  );
}
